import { client } from 'services/http';
import { fetchError, fetchStart, fetchSuccess } from './Common';
import {
  GET_CONVERTABLE_LIST,
  GET_CONVERTABLE_STATUS,
  GET_CONVERT_MOVIE_INFO,
  GET_UPLOAD_MOVIE_INFO,
  PAUSE_CONVERT_MOVIE,
  RQ_COMPANY_TOKEN,
  RQ_CONVERT_MOVIE,
  RQ_FILE_ID,
  SET_CONVERT_FILTER_TYPE,
  SET_DUBBED_FILE_PROPS,
  SET_FILE_PROPS,
  SET_SUBTITLE_FILE_PROPS,
} from '@jumbo/constants/ActionTypes';
import Axios from 'axios';

//For setting Filtertype
export const setConvertFilterType = filterType => {
  return {
    type: SET_CONVERT_FILTER_TYPE,
    payload: filterType,
  };
};

export const getConvertableList = params => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .get(`/share/v1/uploads/movies`, { params: { ...params } })
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: GET_CONVERTABLE_LIST, payload: data.data });
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError('Something went wrong'));
      });
  };
};

export const getUploadMovieInfo = id => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .get(`/share/v2/movies/${id}`)
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: GET_UPLOAD_MOVIE_INFO, payload: data.data });
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError('Something went wrong'));
      });
  };
};

export const rqToConvertMovie = (params, history) => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .post('/share/v1/uploads/movies', params)
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess('با موفقیت ثبت شد'));
          dispatch({ type: RQ_CONVERT_MOVIE, payload: data.data });
          history.push(`/convert-details/?movie=${params.movie_id}`);
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError(error.response?.data?.errors?.base[0]));
      });
  };
};

export const pauseConvertMovie = id => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .delete(`/share/v1/uploads/download_items/${id}`)
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess('عملیات تبدیل متوقف شد'));
          dispatch({ type: PAUSE_CONVERT_MOVIE, payload: data.data });
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError('Something went wrong'));
      });
  };
};

export const getConvertMovieInfo = id => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .get(`/share/v1/uploads/movies/${id}`)
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: GET_CONVERT_MOVIE_INFO, payload: data.data });
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError('Something went wrong'));
      });
  };
};

export const rqToGetCompanyToken = companyID => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .post(`/share/v1/companies/${companyID}/access_tokens`)
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess('توکن دریاقت شد!'));
          dispatch({ type: RQ_COMPANY_TOKEN, payload: data.data });
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError('Something went wrong'));
      });
  };
};

export const rqToGetFileID = params => {
  return dispatch => {
    dispatch(fetchStart());
    Axios.post(
      `https://web.tapture.ir/elitland/user/api/v1/file/create`,
      {
        fileType: 'VIDEO',
        title: params.title,
        description: params.description,
      },
      {
        headers: {
          authorization: `Bearer ${params.companyAccessToken}`,
        },
      },
    )
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess('آماده برای آپلود'));
          dispatch({ type: RQ_FILE_ID, payload: data.data });
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError(error.response.data));
      });
  };
};

export const getConvertableStatus = fileId => {
  return dispatch => {
    dispatch(fetchStart());
    Axios.get(`https://uploader.tapture.ir/elitland/resumable/status/${fileId}`)
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: GET_CONVERTABLE_STATUS, payload: data.data });
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError(error.response?.data?.errors?.base[0]));
      });
  };
};

export const setFileProps = props => {
  return dispatch => {
    dispatch({ type: SET_FILE_PROPS, payload: props });
  };
};

export const setSubtitleFileProps = props => {
  return dispatch => {
    dispatch({ type: SET_SUBTITLE_FILE_PROPS, payload: props });
  };
};

export const setDubbedFileProps = props => {
  return dispatch => {
    dispatch({ type: SET_DUBBED_FILE_PROPS, payload: props });
  };
};

export const uploadSubtitle = ({ subtitleFileData, contentId, setUploadSubtitleLoading }) => {
  return dispatch => {
    const formData = new FormData();
    formData.append('file', subtitleFileData);
    formData.append('contentId', contentId);

    Axios
      .post(`https://uploader.tapture.ir/elitland/subtitle`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess('زیرنویس با موفقیت بارگذاری شد'));
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError('Something went wrong'));
      })
      .finally(() => {
        setUploadSubtitleLoading(false)
      });
  };
};

export const uploadDubbed = ({ dubbedFileData, contentId, setUploadDubbedLoading }) => {
  return dispatch => {
    const formData = new FormData();
    formData.append('file', dubbedFileData);
    formData.append('contentId', contentId);

    Axios
      .post(`https://uploader.tapture.ir/elitland/dubbing`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess('دوبله با موفقیت بارگذاری شد'));
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError('Something went wrong'));
      })
      .finally(() => {
        setUploadDubbedLoading(false)
      });
  };
};